export default __webpack_public_path__ + "static/media/LucidaSans.26124bd7.ttf";